import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createproductGalleryService = async (formValues) => {
  const formData = new FormData();
  formData.append("ProductId", formValues.ProductId);
  formData.append("ColorId", formValues.ColorId);
  formData.append("GalleryType", formValues.GalleryType);

  if (formValues.GalleryFiles) {
    formData.append("GalleryFiles", formValues.GalleryFiles);
  }
  const response = await axiosInstance.post(
    "product/gallery/image",
    formValues,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
      },
    }
  );
  return response.data;
};

export const fetchProductsVariantByProductId = async (productId) => {
  const response = await axiosInstance.get(`products/${productId}/gallery`, {
    headers,
  });
  return response.data;
};

export const updateGalleryOrderService = async (orderData) => {
  const response = await axiosInstance.patch(
    `/product/gallery/update-order`,
    orderData,
    {
      headers,
    }
  );
  return response.data;
};

export const deleteproductGalleryService = async (id) => {
  return await axiosInstance.delete(`product/gallery/${id}`, { headers });
};
